import { render } from "./IconFooter.vue?vue&type=template&id=6cf3acaf"
import script from "./IconFooter.vue?vue&type=script&lang=js"
export * from "./IconFooter.vue?vue&type=script&lang=js"

import "./IconFooter.vue?vue&type=style&index=0&id=6cf3acaf&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__